export default __webpack_public_path__ + "static/media/logo-big-shop.ca25c7fe.png";